import { store, time, bridge, Scheduler, coreEngine } from "@dinahmoe/dmafjs-core";
import { WebAudioSound } from "./sound.js";

class WebAudioSoundStep extends WebAudioSound {
  namespace = "webaudio:sound:step";

  init(node, event) {
    super.init(node);
    node.pendingPlay = new Scheduler(this, this._doPlay);
    node.pendingStop = new Scheduler(this, this._doStop);

    node.index = -1;
    node.lastAssetId = "";
    node.lastPlayTime = 0;
  }

  execute(node, config, event) {
    this.play(node, config, event);
  }

  play(node, config, event) {
    //fadeIn not implemented
    node.pendingStop.clear();
    node.pendingPlay.clear();

    if (node.props.assetIds.length === 0) {
      console.error(`no assetIds defined, ignoring play`);
      return;
    }

    const playAtTime = node.props.ignoreEventTime ? time.current : event.time;
    if (node.props.reTrig > 0 && node.lastPlayTime + node.props.reTrig > time.current) {
      //ignore
      return;
    }

    node.lastPlayTime = time.current;

    node.pendingPlay.schedule(playAtTime, node, playAtTime);
  }

  stop(node, config, event) {
    //fadeOut not implemented
    node.pendingPlay.clear();
    node.pendingStop.clear();

    if (event.time >= time.current) {
      this._doStop(node, time.current, config.fadeOut);
      return;
    }

    node.pendingStop.schedule(event.time, node, event.time, config.fadeOut);
  }

  _doPlay(node, eventTime) {
    const assetId = this.getNextAssetId(node);

    if (!store.get(`assets.buffer.${assetId}`)) {
      console.error(`audio file ${assetId} was not loaded, ignoring play`);
      return;
    }

    node.assetId = assetId;

    bridge.update({
      uid: "webaudio/" + node.uid,
      key: "play",
      value: {
        time: eventTime,
      },
      sender: "core",
    });
  }

  _doStop(node, eventTime, fadeOut) {
    node.assetIds.forEach((assetId) => {
      bridge.update({
        uid: "webaudio/" + node.uid,
        key: "stop",
        value: {
          time: eventTime,
          assetId,
          fadeOut,
        },
        sender: "core",
      });
    });

    //bridge.update("webaudio", {
    //  uid: node.uid,
    //  key: "stop",
    //  value: {
    //    time: eventTime,
    //    assetId: node.props.assetId,
    //    fadeOut,
    //  },
    //});
    node.isPlaying = false;
  }

  getNextAssetId(node) {
    if (node.props.assetIds.length === 1) {
      return node.props.assetIds[0];
    }

    node.index++;
    if (node.index === 0 || node.index === node.assetIds.length) {
      this.shuffleAssetIds(node);
      node.index = 0;

      if (node.lastAssetId === node.props.assetIds[node.index]) {
        node.index++;
      }
    }

    node.lastAssetId = node.props.assetIds[node.index];
    return node.lastAssetId;
  }

  shuffleAssetIds(node) {
    const assetIds = node.props.assetIds;

    for (let i = assetIds.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [assetIds[i], assetIds[j]] = [assetIds[j], assetIds[i]];
    }
  }
}

const webAudioSoundStep = new WebAudioSoundStep();
export { webAudioSoundStep, WebAudioSoundStep };
